'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CartItemField } from './cart-item-field.component';
import { CartItemProcedure } from './cart-item-procedure.component';
import { CartItemRemoveButton } from './cart-item-remove-button.component';
import { CartItemStandaloneField } from './cart-item-standalone-field.component';
import { CartItemWarning } from './cart-item-warning.component';
import { CartItemProps } from './cart-item.types';

import { hasCartItemDiscount } from '@/utils/cart/get-cart-total.util';
import { formatCartItemScheduleLabel } from '@/utils/cart/format-cart-item-schedule.util';
import { isStandaloneCartItem } from '@/utils/cart/is-standalone-cart-item.util';
import { formatSimpleAddress } from '@/utils/formatters/format-address';
import { formatToTitleCase } from '@/utils/formatters/format-to-title-case';

export function CartItemDetails({
  item,
  warning,
  onEditSchedule,
  onEditPatient,
  onRemove,
}: CartItemProps) {
  const isStandalone = isStandaloneCartItem(item);
  const schedule = formatCartItemScheduleLabel(item);
  const patientName = formatToTitleCase(item.patient.socialName || item.patient.legalName);

  const showLocation = !item.procedure.isTelehealth;
  const locationAddress = formatSimpleAddress(item.partner.facility);

  return (
    <>
      <CartItemProcedure item={item} />

      {!hasCartItemDiscount(item) && <hr className="border-t border-gray-300" />}

      {isStandalone && <CartItemStandaloneField />}

      {!isStandalone && schedule && (
        <CartItemField
          label="Data e hora"
          value={<span>{schedule}</span>}
          dataTestId={DataTestIdEnum.CART_ITEM_FIELD_SCHEDULE}
          action={onEditSchedule && {
            label: 'Alterar data e hora',
            dataTestId: DataTestIdEnum.CART_ITEM_EDIT_SCHEDULE_BUTTON,
            onClick: onEditSchedule,
          }}
        />
      )}

      {warning && <CartItemWarning>{warning}</CartItemWarning>}

      <CartItemField
        label="Atendimento para"
        value={<span>{patientName}</span>}
        dataTestId={DataTestIdEnum.CART_ITEM_FIELD_PATIENT}
        action={onEditPatient && {
          label: 'Alterar paciente',
          dataTestId: DataTestIdEnum.CART_ITEM_EDIT_PATIENT_BUTTON,
          onClick: onEditPatient,
        }}
      />

      {showLocation && (
        <CartItemField
          label="Local"
          dataTestId={DataTestIdEnum.CART_ITEM_FIELD_LOCATION}
          value={(
            <>
              <span>{formatToTitleCase(item.partner.facility.name)}</span>
              <span>{locationAddress}</span>
            </>
          )}
        />
      )}

      {onRemove && <CartItemRemoveButton onRemove={onRemove} />}
    </>
  );
}
